"use client";

import { type ModuleResourceList } from "@lib/types";
import Link from "next/link";

import { Container } from "@/components/ui/container";

export function ResourceListModule({ module }: { module: ModuleResourceList }) {
  if (!module.items || module.items.length === 0) return null;

  return (
    <Container as="section" className="flex flex-col gap-8">
      <div className="px-padding-section-md md:px-padding-element-xl w-full max-w-none space-y-4">
        {module.items.map((item, index) => {
          const resourceUrl = item.file?.asset?.url || item.url;
          const ctaLabel = item.ctaLabel || "View";

          return (
            <div
              key={item._key}
              className={`py-padding-element-xl mb-0 flex items-center justify-between border-b border-white/20 ${
                index === 0 ? "border-t" : ""
              }`}
            >
              <div className="py-padding-element-md flex flex-col gap-1">
                <span className="typography-heading-6 text-white">{item.title}</span>
                {item.description ? (
                  <span className="typography-text-regular-normal tablet:typography-text-medium-normal text-white">
                    {item.description}
                  </span>
                ) : null}
              </div>
              {resourceUrl ? (
                <Link
                  href={resourceUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="typography-text-regular-normal tablet:typography-text-medium-normal flex items-center gap-2 text-white transition-colors hover:text-white"
                >
                  {ctaLabel}
                  <svg
                    className="size-4"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M9 5l7 7-7 7"
                    />
                  </svg>
                </Link>
              ) : null}
            </div>
          );
        })}
      </div>
    </Container>
  );
}
